import * as core from '../../../../../../../core'

import { query } from './stakeholders-by-support-level.query'

export const RESOURCE = {
  payload: {
    alias: 'stakeholders.by.support.level',
    description: 'Chart view of stakeholders by support level',
    name: 'Stakeholders by Support Level',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
